"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const React = require("react");
const config_1 = require("../config/config");
const AppSpinnerStyle_1 = require("./jss/AppSpinnerStyle");
const AppSpinner = ({ label, classes, positionFixed, customStyles, persistSpinner = false }) => {
    const [show, setShow] = React.useState(true);
    const positionStyle = { position: positionFixed ? 'fixed' : 'absolute' };
    const componentStyles = customStyles
        ? Object.assign(Object.assign({}, positionStyle), customStyles) : positionStyle;
    React.useEffect(() => {
        if (persistSpinner !== true) {
            const showTimeout = setTimeout(() => {
                setShow(false);
            }, 3000);
            return () => {
                clearTimeout(showTimeout);
            };
        }
    }, []);
    if (!show)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.root, style: componentStyles }, { children: [(0, jsx_runtime_1.jsx)(core_1.CircularProgress, { style: { color: config_1.config.themeColors.warningColor.hex() }, size: 28 }), (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "body1", className: classes.label }, { children: label }))] })));
};
exports.default = (0, core_1.withStyles)(AppSpinnerStyle_1.default)(AppSpinner);
//# sourceMappingURL=AppSpinner.js.map